import initialState from '../state/loading';
import CONSTANTS from '../../_constants';

export default function loadingReducer(state = initialState, action) {
  switch (action.type) {
    case CONSTANTS.LOADING:
      return action.payload;
    default:
      return state;
  }
}